// extracted by mini-css-extract-plugin
module.exports = {"recommender":"Z-z"};